import * as React from "react"
import {
  BooleanField,
  CreateButton,
  DatagridConfigurable,
  DateField,
  List,
  SearchInput,
  TopToolbar,
  TextField,
  useListContext,
  ReferenceField,
  DeleteWithConfirmButton,
  BulkDeleteButton,
  useRecordContext
} from "react-admin"
import { useMediaQuery, Button, Box } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';
import CategoryFilterForm from "./CategoryFilterForm"

const CategoryFilterButton = () => {
  const { showFilter } = useListContext()
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
      sx={{
        height: '27.5px', // 調整按鈕高度
        padding: '4px 5px', // 調整內邊距
        fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
      }}
    >
      篩選
    </Button>
  )
}

const mobileFilters = [
  <SearchInput source="q" alwaysOn />
]

const CategoryListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <CategoryFilterButton />
      <CreateButton />
    </TopToolbar>
    <CategoryFilterForm />
  </Box>
)

const CategoryBulkActionButtons = () => (
  <>
    <BulkDeleteButton 
      confirmTitle="確認刪除"
      confirmContent="您確定要刪除這些類別嗎？"
      mutationMode="optimistic"
    />
  </>
);

const CategoryTitle = () => {
  return <span>{'商品系列'}</span>;
};

// 只在 name !== '服飾專區' 時顯示刪除
const ConditionalDeleteButton = (props) => {
  const record = useRecordContext();
  if (!record) return null;
  if (String(record.name).trim() === "服飾專區") return null;
  return <DeleteWithConfirmButton {...props} />;
};

const CategoryList = () => {
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))

  return (
    <List
      title={<CategoryTitle/>}
      filters={isSmall ? mobileFilters : undefined}
      sort={{ field: "sorting", order: "ASC" }}
      perPage={25}
      actions={<CategoryListActions />}
    >
      {isXsmall ? (
        <div></div>
      ) : (
        <DatagridConfigurable
          rowClick="edit"
          bulkActionButtons={<CategoryBulkActionButtons />}
          isRowSelectable={(record) => (record?.name || '').trim() !== '服飾專區'}
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            }
          }}
          omit={["id"]}
        >
          <TextField
            source="id"
            label="ID"
          />
          <TextField
            source="sorting"
            label="排序編號"
          />
          <TextField
            source="name"
            label="名稱"
          />
          <ReferenceField 
            source="parentId" 
            reference="categories" 
            label="父類別"
          >
            <TextField source="name" />
          </ReferenceField>
          <BooleanField
            source="status"
            label="起用狀態"
          />
          <DateField 
            source="createdAt" 
            label="建立日期"  
            showTime
          />
          <ConditionalDeleteButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此類別嗎？"
          />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default CategoryList